import { getMethod } from 'core-lib/utils/apiV2';
import { formatUrlWithQuery } from 'core-lib/utils/utils';

export type EligibilityType = {
  eligible: boolean;
  linked: boolean;
  token: string;
  webViewUrl: string;
  availableCreditLimit: number;
  description: string;
  errorMessage: string;
};

export const serializeCheckEligibility = (data: any) => {
  const paymentPayload = data?.payment_payload;

  const obj: EligibilityType = {
    eligible: paymentPayload?.eligible,
    linked: paymentPayload?.linked,
    token: paymentPayload?.token,
    webViewUrl: paymentPayload?.web_view_url,
    availableCreditLimit: paymentPayload?.available_credit_limit,
    description: data?.description,
    errorMessage: data?.not_show_user_message,
  };

  return obj;
};

export const checkEligibility = async (url: string, amount=0) => {
  const endPoint = formatUrlWithQuery(url, 'amount', amount);
  const { response }: any = await getMethod({
    endPoint,
  });

  if (response?.data) {
    return { response: serializeCheckEligibility(response.data) };
  }
  return { response: null };
};
